import React from 'react';
import configuration from './config.js';

var UserPhoto ;
var display = "block" ;

if ( JSON.parse(localStorage.getItem("user")).avatar === "photo_0.png"  ){
	display = "none" ;
}
 
	UserPhoto = () => (
		<div>
	        <img src={configuration.urlDocuments + 'users/' + JSON.parse(localStorage.getItem("user")).avatar}
	        	style={{ "display": display,
	        			"marginLeft": "auto",
  						"marginRight": "auto",
  						"width": "30%"
  						}}  alt=''
	         />
		</div>
	);
 

export default  UserPhoto ;
